<div class="container-fluid" style="max-height: 75vh; overflow-y: auto;">
<div class="row">

    <h2 class="col-sm-12 text-center" style="background-color: black; color: white; padding: 10px;">Wallpaper Management</h2>
    <div  class="col-sm-12 mb-4">
      <mat-slide-toggle [(ngModel)]="switcher_toggle_navigator"> Toggle Navigator</mat-slide-toggle>
    </div>

    <div class="col-sm-5 mb-4">
      <!--  Navigator-->
      <div [hidden]="!switcher_toggle_navigator">
        <div >
          <form>
            <mat-form-field appearance="fill">
              <mat-label>Sort tree by</mat-label>
              <mat-select [(ngModel)]="sort_tree_by" name="item">
                <mat-option *ngFor="let item of sort_by_list" [value]="item.value">
                  {{item.viewValue}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            </form>
          <app-treeview-systems
            parent_icon="folder"
            child_icon="videocam"
            parent_table_name="ngaccessmanagement_ngfoldertree"
            parent_table_pk="id"
            parent_table_ref_value="item_name"
            child_table_name="ngaccessmanagement_ngsystemprofile"
            child_table_displayname="system_name"
            child_table_fk="folder_id_id"
            algorithm="m2mtable"
            title="Location"
            [sort_by] = sort_tree_by
            (messageSelectedMultipleNodesWithTheirText)="recieve_selected_multiple_items($event)"
          ></app-treeview-systems>
        </div>
      </div>
    </div>

    <div class="col-sm-7 text-center">
      <h3 style="background-color: black; color: white; padding: 10px;">Units selected</h3>

      <h3 *ngIf="this.received_selected_items?.length==0" style="color:red">
        * Select units from tree
      </h3>

      <h5 *ngIf="this.received_selected_items?.length>0" style="color:blue" class="align-left">
        * Total number of units selected are {{this.received_selected_items.length}}
      </h5>

      <div style="max-height:75vh;overflow-y:auto;">

        <table *ngIf="this.received_selected_items?.length>0"
          mat-table [dataSource]="this.received_selected_items"
          class="mat-elevation-z8 col-sm-12">

          <ng-container matColumnDef="deleteIcon" >
            <th mat-header-cell *matHeaderCellDef class="text-center"></th>
            <td mat-cell *matCellDef="let element;" class=" text-center">
                <mat-icon aria-hidden="false" aria-label="delete_forever" matTooltip="Remove"
              class="deleteSingleRow" style="color: yellowgreen;">computer</mat-icon>
          </td>

          </ng-container>

          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef class="text-center"> Unit Name - Unit IP</th>
            <td mat-cell *matCellDef="let element;"  class=" text-center">
              {{element.text}}
          </td>
          </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>

      </div>

        <div id="closeBtn">
          <mat-icon aria-hidden="false" class="fa-2x"  style="width: 100%; color: grey;" id="closeBtn" (click)="onNoClick()">close</mat-icon>
        </div>
      </div>

  <div class="row">
      <div class="col-sm-12 text-center mb-4" id="wallpapers" style="background-color: honeydew;">
          <h3 style="background-color: black; color: white; padding: 10px;">Available images</h3>
          <mat-form-field appearance="fill" style="width: 30%; margin: 0px 2px 0px 2px; ">
            <mat-label>Images Names</mat-label>
            <mat-select [(value)]="selectedImage" >
            <mat-option *ngFor="let image of imagesNames" [value]="image">{{image}}</mat-option>
            </mat-select >
            </mat-form-field>

            <button style="min-width: 10%;margin: 0px 2px 0px 20px !important; "
            mat-raised-button color="primary"
            (click)="getImageUrl()" [disabled]="!selectedImage">
              Preview
            </button>
            <div class="col-sm-12" *ngIf="imageSource">
              <img [src]="imageSource" [alt]="selectedImage">
            </div>
      <div>

    <div  class="text-center  col-sm-12">
      <button  mat-raised-button color="primary" style="color: white;min-width: 10%; border: none; font-weight: bold;"
      class="optionBtn" (click)="openConfirmDialog()" [disabled]="!selectedImage || received_selected_items.length==0||requestSentFlag">Push</button>
      <button  mat-raised-button color="warn" style="color: white;min-width: 10%; border: none; font-weight: bold;"
      class="optionBtn" (click)="onNoClick()" >Cancel</button>
    </div>
  </div>
</div>


